module.exports = __webpack_public_path__ + "static/PostGrotesk-Book-ccb6b63c6b7420a80af99ac2feeff64c.eot";